
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type RegoSearchPanelTabRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function RegoSearchPanelTabRT(): TemplateResult<RegoSearchPanelTabRTRootProps> {
    function onClick1(e) {
        window.Convermax.regoSearch(e);
    }
    return _createElement('div', { 'className': 'cm_rego-search' }, _createElement('div', { 'className': 'cm_rego-search-form vf-form' }, _createElement('input', {
        'type': 'text',
        'className': 'cm_rego-search-input vf-input',
        'placeholder': 'Enter Rego',
        'aria-label': 'Enter Rego'
    }), _createElement('div', { 'className': 'cm_rego-search-select-container vf-select-wrapper' }, _createElement('select', {
        'className': 'cm_rego-search-select vf-select',
        'data-field': 'state',
        'aria-label': 'Select State'
    }, [
        _createElement('option', {
            'value': true,
            'selected': true,
            'disabled': true,
            'key': '3610'
        }, 'Select State'),
        _createElement('option', {
            'value': 'NSW',
            'key': '3612'
        }, 'NSW'),
        _createElement('option', {
            'value': 'VIC',
            'key': '3614'
        }, 'VIC'),
        _createElement('option', {
            'value': 'QLD',
            'key': '3616'
        }, 'QLD'),
        _createElement('option', {
            'value': 'WA',
            'key': '3618'
        }, 'WA'),
        _createElement('option', {
            'value': 'SA',
            'key': '36110'
        }, 'SA'),
        _createElement('option', {
            'value': 'TAS',
            'key': '36112'
        }, 'TAS'),
        _createElement('option', {
            'value': 'ACT',
            'key': '36114'
        }, 'ACT'),
        _createElement('option', {
            'value': 'NT',
            'key': '36116'
        }, 'NT')
    ])), _createElement('button', {
        'className': 'cm_rego-search-button vf-submit',
        'type': 'button',
        'onClick': onClick1.bind(this)
    }, [_createElement('svg', {
            'viewBox': '0 0 24 24',
            'width': '32',
            'height': '32',
            'fill': 'none',
            'aria-hidden': 'true',
            'key': '8590'
        }, _createElement('path', {
            'd': 'M2.36895 14.222C2.82573 15.3246 3.47612 16.2979 4.32014 17.1418C5.16416 17.9857 6.13755 18.636 7.24032 19.0927C8.34308 19.5495 9.49127 19.7778 10.6849 19.7778C11.8785 19.7778 13.0267 19.5495 14.1295 19.0927C15.2322 18.636 16.2056 17.9857 17.0496 17.1418C17.8937 16.2979 18.5441 15.3246 19.0008 14.222C19.4576 13.1194 19.686 11.9713 19.686 10.7778C19.686 9.58436 19.4576 8.43631 19.0008 7.33368C18.5441 6.23105 17.8937 5.25778 17.0496 4.41387C16.2056 3.56996 15.2322 2.91964 14.1295 2.46292C13.0267 2.00619 11.8785 1.77783 10.6849 1.77783C9.49127 1.77783 8.34308 2.00619 7.24032 2.46292C6.13755 2.91964 5.16416 3.56996 4.32014 4.41387C3.47612 5.25778 2.82573 6.23105 2.36895 7.33368C1.91217 8.43631 1.68378 9.58436 1.68378 10.7778C1.68378 11.9713 1.91217 13.1194 2.36895 14.222Z',
            'stroke': 'currentColor',
            'strokeLinecap': 'round',
            'strokeLinejoin': 'round',
            'strokeWidth': '2'
        }), _createElement('path', {
            'd': 'M0 0L7.25967 0',
            'stroke': 'currentColor',
            'strokeLinecap': 'square',
            'strokeLinejoin': 'round',
            'strokeWidth': '2',
            'transform': 'matrix(0.687737,0.72596,-0.72596,0.687737,17.4221,17.3333)'
        }))], '\n      FIND PARTS\n    ')));
}
        export const componentNames = []